import React from 'react';
import styled from 'styled-components';
import {Avatar} from "@mui/material";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import SearchIcon from '@mui/icons-material/Search';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../firebase';
import ChatbotDropdown from './ChatbotDropdown';
// import {DropBox} from './ChatbotDropdown';


function Header() {
  const [user]= useAuthState(auth);
  return (
    <HeaderContainer>
        {/* <div>Header container</div> */}
        {/* Header left */}
        <HeaderLeft>
          <HeaderAvatar onClick={()=>auth.signOut()}
             alt={user?.displayName} src={user?.photoURL}
          />
          <abbr title="online"><AccessTimeIcon/></abbr>
          </HeaderLeft>
      

        {/* Header Search */}
        <HeaderSearch>
          <SearchIcon/>
          <input placeholder='Search SlackFlow'/>
        </HeaderSearch>

       <ChatbotDropdown/>


        {/* Header Right */}
        <HeaderRight>
          <abbr title="Help: ss8708582@gmail.com"><HelpOutlineIcon/></abbr>
        </HeaderRight>
    </HeaderContainer>
    
  )
}

export default Header;

const HeaderSearch = styled.div`
flex: 0.4;
opacity: 1;
border-radius: 6px;
background-color: #435162;
text-align: center;
display: flex;
padding:0 50px;
color: gray;
border: 1px gray solid;

>input {
  background-color: transparent;
  border: none;
  text-align: center;
  min-width: 30vw;
  outline:0;
  color: white;
}
`;

const HeaderContainer= styled.div`
display: flex;
position: fixed;
width: 100%;
align-items:  center;
justify-content: space-between;
padding:  10px 0;
background-color:var(--slack-color) ;
color: white;

`;

const HeaderLeft=styled.div`
flex: 0.3;
display: flex;
align-items: center;
margin-left: 20px;
>abbr{
  
}
>abbr>.MuiSvgIcon-root{
  position: absolute;
  margin-left:50vh;
  margin-top: -11px;
  /* margin-right:30px; */
}

`;

const HeaderRight=styled.div`
>abbr{flex:0.3;
display: flex;
align-items: flex-end;
}
>abbr>.MuiSvgIcon-root{
  margin-left:  auto;
  margin-right: 20px;
}
`;

const HeaderAvatar = styled(Avatar)`
  cursor:pointer;
  :hover{
    opacity:0.8;
  }
`;


